import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useDispatch } from "react-redux";

import PrimaryButton from "@/components/UI/PrimaryButton/PrimaryButton";
import SecondaryButton from "@/components/UI/SecondaryButton/SecondaryButton";
import { ELEMENT_STATUS } from "@/constants";
import { resetCurrentElement, setSimpleValue } from "@/store/actions";

const useStyles = makeStyles({
  container: {
    display: "flex",
    gap: "32px",
  },
});

export default function ElementFormActions(props) {
  const { element, formValues, disabled, onUpdate, onCreate, isDirty, reset } = props;
  const classes = useStyles();

  const dispatch = useDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <div className={classes.container} data-testid="element-form-buttons-container">
      {formValues.status === ELEMENT_STATUS.DRAFT && (
        <PrimaryButton
          disabled={disabled || isSubmitting}
          onClick={() => {
            setIsSubmitting(true);
            onCreate(() => setTimeout(() => setIsSubmitting(false), 300));
          }}
          data-testid="element-form-create-button"
          data-analytics={`${element.type}-button-create`}
        >
          Create
        </PrimaryButton>
      )}
      {formValues.status === ELEMENT_STATUS.CREATED && (
        <>
          <SecondaryButton
            onClick={() => {
              dispatch(setSimpleValue("selectedElementId", element.id));
              dispatch(resetCurrentElement());
            }}
            data-testid="element-form-delete-button"
            data-analytics={`${element.type}-edit-delete`}
          >
            Delete
          </SecondaryButton>
          <PrimaryButton
            disabled={disabled || isSubmitting || !isDirty}
            onClick={() => {
              setIsSubmitting(true);
              onUpdate(element, formValues, () =>
                setTimeout(() => {
                  setIsSubmitting(false);
                  reset(formValues);
                }, 300),
              );
            }}
            data-testid="element-form-update-button"
            data-analytics={`${element.type}-edit-update`}
          >
            Update
          </PrimaryButton>
        </>
      )}
    </div>
  );
}
